import * as Flickity from 'flickity';

export class ProductHeader {
    private container: JQuery;
    private slider: JQuery;
    private thumbs: JQuery;
    private carousel!: Flickity;


    /**
     * Creates a new instance of SplitScreen
     *
     * @param container The containing element
     */
    constructor(container: HTMLElement) {
        this.container = $(container);
        this.thumbs    = $('.js-product-header__thumb');
        this.slider    = this.container.find('.js-product-header__carousel');

        this.createCarousel();
        this.thumbnails();
    }


    /**
     * Initializes Flickity for the carousel.
     *
     * @private
     * @memberof SplitScreen
     */
    protected createCarousel(): void {

        this.carousel = new Flickity(this.slider.get(0), {
            wrapAround: true,
            cellAlign: 'left',
            pageDots: false,
            setGallerySize: false,
            prevNextButtons: false
        });

        this.carousel.on('select', () => {
            this.thumbs.each((index, link) => {
                console.log(index, this.carousel.selectedIndex);
                
                if(index === this.carousel.selectedIndex) {
                    $(link).addClass('c-product-header__thumb-link--is-active');
                } else {
                    $(link).removeClass('c-product-header__thumb-link--is-active');
                }
            });
        });
    }


    /**
     * Enables clicking on the thumbnails to change the slide.
     *
     * @protected
     * @memberof ProductHeader
     */
    protected thumbnails(): void {
        this.thumbs.each((index, link) => {
            $(link).on('click', (event) => {

                // Change the current carousel slide.
                this.carousel.select(index);
    
                // Stop the page changing
                event.preventDefault();
            });
        });
    }
}
